import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[720px] md:h-[820px] overflow-hidden">
      <img
        src="images/main.webp"
        alt="マンション清掃"
        className="absolute inset-0 w-full h-full object-cover object-top brightness-105"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/15 via-primary-950/5 to-primary-950/15"></div>

      <div className="relative z-10 w-full h-full flex items-center -translate-y-8">
        <div className="mx-auto max-w-7xl w-full px-4 md:px-10">
          <div className="max-w-3xl fade-up text-center md:text-left mx-auto md:mx-0">
            <h1 className="font-heading text-background-50 text-4xl md:text-6xl leading-[1.15] mb-6 drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">
              一番きれいを、<br className="hidden md:block" />
              目指す会社。
            </h1>
            <p className="text-background-100/95 text-base md:text-lg leading-relaxed mb-8 max-w-2xl mx-auto md:mx-0 text-slate-900">
              「安ければ雑、丁寧なら高い」——その常識を変えていきます。
               20年の現場経験とオーナー視点で、資産価値を守る清掃をご提案いたします。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center md:justify-start">
              <Link
                to="/contact"
                className="bg-accent-500 hover:bg-accent-600 text-background-50 font-medium px-7 py-4 rounded-md text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 text-slate-900"
              >
                <i className="ri-file-list-3-line"></i>
                無料お見積を依頼する
              </Link>
              <Link
                to="/services"
                className="border border-background-100/50 text-background-50 hover:bg-background-50/10 px-7 py-4 rounded-md text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 text-slate-900"
              >
                サービスを見る
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-background-100/70 text-xs tracking-widest flex flex-col items-center drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">
        <span className="drop-shadow-[0_2px_3px_rgba(0,0,0,0.7)]">SCROLL</span>
        <span className="w-px h-8 bg-background-100/40 mt-2"></span>
      </div>
    </section>
  );
}